import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ProfilesRights, RightsService } from 'src/Services/API';

import { useAuth } from '../Authentication/useAuth';
import { QueryKeys } from '../types';

export const useFetchProfilesRights = (
  extraOptions?: UseQueryOptions<ProfilesRights[], AxiosError>
) => {
  const { isAuthenticated } = useAuth();

  return useQuery<ProfilesRights[], AxiosError>(
    [QueryKeys.fetchProfilesRights],
    async () => {
      return await RightsService.rightsControllerGetProfilesRights();
    },
    {
      enabled: isAuthenticated,
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      ...extraOptions,
    }
  );
};
